import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import { computed } from "vue";
import AccountInput from "./account-input.vue";

/* eslint-disable @typescript-eslint/naming-convention */

export default /*@__PURE__*/_defineComponent({
  __name: 'checkbox-input',
  props: /*@__PURE__*/_mergeModels({
    modelValue: { type: Boolean },
    name: {},
    description: {},
    note: {},
    mandatory: { type: Boolean },
    preventDefault: { type: Boolean }
  }, {
    "errorMessage": {},
    "errorMessageModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue", "inputErrorDetected", "click"], ["update:errorMessage"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const props = __props;

const errorMessage = _useModel<string>(__props, "errorMessage");

const checkboxValue = computed({
    get() {
        return props.modelValue;
    },
    set(newValue) {
        errorMessage.value = null;
        emit("update:modelValue", newValue);
    },
});

const checkIfIsValid = (): boolean => {
    let isValid = true;

    if (props.mandatory && !props.modelValue) {
        errorMessage.value = "Tento souhlas je povinný.";
        isValid = false;
    }

    return isValid;
};

const checkboxClick = (e) => {
    if (props.preventDefault) {
        e.preventDefault();
    }

    emit("click");
};

__expose({
    checkIfIsValid,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccountInput, {
    class: "checkbox-input",
    errorMessage: errorMessage.value,
    name: _ctx.name,
    onInputErrorDetected: _cache[1] || (_cache[1] = ($event: any) => (emit('inputErrorDetected', _ctx.name, errorMessage.value)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("label", {
        for: _ctx.name,
        class: "checkbox-input__label"
      }, [
        _withDirectives(_createElementVNode("input", {
          class: "checkbox-input__input",
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkboxValue).value = $event)),
          id: _ctx.name,
          onClick: checkboxClick
        }, null, 8, _hoisted_2), [
          [_vModelCheckbox, checkboxValue.value]
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "checkbox-input__checkmark" }, null, -1)),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "checkbox-input__text",
            innerHTML: _ctx.description
          }, null, 8, _hoisted_3),
          _withDirectives(_createElementVNode("div", {
            class: "checkbox-input__note agree__text",
            innerHTML: _ctx.note
          }, null, 8, _hoisted_4), [
            [_vShow, _ctx.note]
          ])
        ])
      ], 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["errorMessage", "name"]))
}
}

})